import React from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/components/CaseStudies.css";

import arrowCircle from "../../img/hero/ArrowUpRight-2.png";

import appsImg from "../../img/cases/case-apps.webp";
import websitesImg from "../../img/cases/case-websites.webp";
import coachesImg from "../../img/cases/case-coaches.webp";

const cases = [
  {
    title: "Apps",
    image: appsImg,
    type: "small",
    href: "/cases/apps",
  },
  {
    title: "Websites",
    image: websitesImg,
    type: "small",
    href: "/cases/websites",
  },
  {
    title: "AI coaches",
    image: coachesImg,
    type: "wide",
    href: "/cases/ai-agents",
  },
];

export default function CaseStudies() {
  const navigate = useNavigate();

  return (
    <section className="cs">
      <h2 className="cs__title cs-anim">Case studies</h2>

      <div className="cs__grid">
        {cases.map((item) => (
          <article
            key={item.title}
            className={`cs-card cs-anim cs-card--${item.type}`}
          >
            <h3 className="cs-card__title">{item.title}</h3>

            <img
              className={`cs-card__image ${
                item.title === "Apps"
                  ? "cs-card__image--apps"
                  : item.title === "Websites"
                    ? "cs-card__image--websites"
                    : "cs-card__image--coaches"
              }`}
              src={item.image}
              alt=""
              aria-hidden="true"
            />

            <button
              className="cs-card__btn"
              type="button"
              onClick={() => navigate("/cases")}
            >
              <span>View all</span>
              <img src={arrowCircle} alt="" aria-hidden="true" />
            </button>
          </article>
        ))}
      </div>
    </section>
  );
}
